import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {View, StyleSheet} from 'react-native';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {WebFrame} from 'interface/base/WebFrame';
import storage from 'extensions/storage';
import {getHost} from 'utils/platform';
import {name} from 'config/app';

import type {WebViewMessageEvent} from 'react-native-webview';

export function useModalUpsellProTrial() {
  const {t} = useLingui();
  const toast = useToast();
  const modal = useModal();
  const exit = useCallback(() => modal.exit(), []);
  const message = useCallback((e: WebViewMessageEvent) => {
    if (e && e.nativeEvent.data === 'mf-close-dialogs')
      exit();
    if (e.nativeEvent.url !== 'https://checkout.mediafire.com'
      && e.nativeEvent.url !== 'https://www.mediafire.com')
      return;
    switch (e.nativeEvent.data) {
      case 'mf-trial-close':
        exit();
        break;
      case 'mf-trial-denied':
        toast.show(t`Credit card declined. Please verify details are correct.`, {type: 'danger'});
        break;
    }
  }, []);

  const show = useCallback(() => {
    storage.init(name).setItem('upsell:trial', '1');
    modal.open(
      <View style={styles.root}>
        <WebFrame
          isProTrialSignup
          url={`${getHost()}/widgets/premium_trial.php`}
          onMessage={message}
          exit={exit}
        />
      </View>,
      {frameless: true, overlay: true},
    );
  }, []);

  return [show, exit];
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    width: 580,
    height: 370,
    alignSelf: 'center',
    justifyContent: 'center',
  },
});
